import { useNavigate, useSearchParams } from "react-router";
import { RoomType } from "@prisma/client";
import ProfileButton from "@app/components/ProfileButton";
import { useEffect, useMemo, useRef } from "react";
import useUser from "@app/zustand/user";
import { UserConnexionResponse } from "@api/src/types/responses";
import useMinimumWidth from "@app/utils/useMinimumWidth";

export default function FeedHeader({ setNewPostModalOpen }: { setNewPostModalOpen: (open: boolean) => void }) {
  const me = useUser((state) => state.user!);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const qFavs = searchParams.get("qFavs");
  const isSearch = searchParams.has("search");
  const isMd = useMinimumWidth("md");

  useEffect(() => {
    if (navigator.clearAppBadge) {
      navigator.clearAppBadge();
    }
  }, []);

  const buttonContent = useMemo(() => {
    if (!isMd) {
      return "Commencez à écrire ici...";
    }
    switch (searchParams.get("qRoomType") as RoomType) {
      case RoomType.ETABLISSEMENT:
        return "Écrivez ici : Article - Sondage - Expérience - Recherche - Formation - Événement...";
      case RoomType.DIRECT:
        return "Nouveau message";
      case RoomType.STATUS_PRO:
      case RoomType.SPECIALITE:
      default:
        return "Un article, une expérience, une question\u00A0? Écrivez ici...";
    }
  }, [searchParams, isMd]);

  const debounceSearchTimeout = useRef<NodeJS.Timeout | null>(null);

  if (qFavs) {
    return null;
  }

  /* <RegisterWebPushNotificationsButton className="mb-4" /> */

  return (
    <div className="drop-shadow-xs flex w-full rounded-lg border border-gray-200 bg-white p-4" suppressHydrationWarning>
      <ProfileButton user={me} />
      {isSearch ? (
        <input
          type="search"
          name="search"
          className="ml-3 flex-grow overflow-x-auto scroll-smooth whitespace-nowrap rounded-full  border border-sky-900 border-opacity-30 px-4 text-left text-sky-900"
          placeholder="Écrivez ici pour rechercher un contenu dans tous vos canaux de discussion"
          onChange={(e) => {
            if (debounceSearchTimeout.current) clearTimeout(debounceSearchTimeout.current);
            debounceSearchTimeout.current = setTimeout(() => {
              searchParams.set("search", e.target.value);
              setSearchParams(searchParams);
            }, 300);
          }}
        />
      ) : (
        <button
          type="button"
          onClick={() => {
            if (me?.verifiedAt) {
              setNewPostModalOpen(true);
            } else {
              fetch(`${import.meta.env.VITE_API_URL}/user/login-redirect`, {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  email: me.email,
                }),
              })
                .then((response) => response.json() as Promise<UserConnexionResponse>)
                .then((response) => {
                  if (response.message === "Redirect to OTP") {
                    console.log("Redirect to OTP", response.data.user?.email);
                    navigate(`/welcome/login-redirect?email=${encodeURIComponent(String(response.data.user?.email))}`);
                  } else if (response.message === "Redirect to Login Profile") {
                    navigate("/welcome/login-profile");
                  } else if (response.error) {
                    alert(response.error);
                  } else if (response.ok) {
                    navigate("/");
                  }
                });
            }
          }}
          className="ml-3 flex-grow overflow-x-auto scroll-smooth whitespace-nowrap rounded-full  border border-sky-900 border-opacity-30 px-4 text-left text-sky-900"
        >
          {buttonContent}
        </button>
      )}
    </div>
  );
}
